import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vShow as _vShow, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "labeltitle" }
const _hoisted_2 = { class: "labeltitle" }
const _hoisted_3 = ["readonly"]
const _hoisted_4 = { class: "labeltitle" }
const _hoisted_5 = { class: "labeltitle" }
const _hoisted_6 = { class: "labeltitle" }
const _hoisted_7 = { class: "labeltitle" }
const _hoisted_8 = { value: "0" }
const _hoisted_9 = { value: "1" }
const _hoisted_10 = { value: "2" }
const _hoisted_11 = { value: "3" }
const _hoisted_12 = { value: "4" }
const _hoisted_13 = { class: "labeltitle" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "labeltitle" }, "Transfer Syntax", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, " LE EXPLICIT", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, " JPEG LOSSLESS", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, " JPEG LOSSY", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, " JPEG 2K LOSSLESS", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "4" }, " JPEG 2K LOSSY", -1)
const _hoisted_20 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "labeltitle" }
const _hoisted_22 = { class: "labeltitle" }
const _hoisted_23 = { class: "labeltitle" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  style: {"width":"100%","height":"75%"},
  for: "Picture"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-signature" }, null, -1)
const _hoisted_27 = { class: "labeltitle" }
const _hoisted_28 = { class: "labeltitle" }
const _hoisted_29 = { class: "labeltitle" }
const _hoisted_30 = ["value"]

import { onMounted, ref } from "vue";
import { useStore } from 'vuex';
import axios from "axios";

interface printer {
    AET: string;
    IPAddress: string;
    PortNumber: string;
    gamma: number;
    contrast: number;
    destination: number;
    orientation: number;
    mediumType: number;
    filmSize: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersEdit',
  props: ['selectedUser'],
  emits: ['close'],
  setup(__props, { emit: emits }) {

const props = __props;



const store = useStore();

var user = ref({
    UserName: "",
    PassWord: "",
    Signature: "",
    Rights: 0,
    TransSyntax: 1,
    Image: "",
    PrinterAET: ""
});

var printers = ref<printer[]>([]);
var title = ref("Edit User");
var editMode = ref(true);
var filePicture: File;
var fileName = ref("");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadSignature(event: any) {
    if (event.target !=null){
        filePicture = event.target.files[0];
        var reader = new FileReader();
        var imgtag = document.getElementById("SignatureImage") as HTMLImageElement;
        if (imgtag != null) {
            imgtag.title = filePicture.name;
            reader.onload = function (event) {
                if ((imgtag != null) && (event.target != null)) {
                    imgtag.src = event.target.result;
                }
            };
            reader.readAsDataURL(filePicture);
        }
    }
}

function closeCancel() {
    emits('close');
}

async function closeOk() {
    console.log("closeOk", user.value);
    if (user.value.UserName.length == 0) {
        alert("Add User ERROR: User Name can't be empty");
        return;
    }
    const formData = new FormData();
    formData.append("UserName", user.value.UserName);
    formData.append("PassWord", user.value.PassWord);
    formData.append("Signature", user.value.Signature);
    formData.append("Rights", String(user.value.Rights));
    formData.append("TransSyntax", String(user.value.TransSyntax));
    formData.append("PrinterAET", user.value.PrinterAET);
    if (filePicture!=null) {
        formData.append("File", filePicture);
    }
    const auth = "Bearer " + store.state.tokenValue;
    var url = store.state.rootURL;

    if (editMode.value) {
        url = url + "/userupdate";
    } else {
        if (user.value.PassWord.length == 0) {
            alert("Add User ERROR: PassWord can't be empty");
            return;
        }
        url = url + "/usernew";
    }
    const response = await axios.post(url, formData, {
        headers: {
            Authorization: auth,
            "Content-Type": "multipart/form-data",
        },
    });
    alert(response.data);
    emits('close');
}

onMounted(async () => {
    printers.value = await store.dispatch('HTTPGet', { url: 'dicomprinters' });
    if (props.selectedUser != null) {
        user.value = props.selectedUser;
        user.value.PassWord="";
        console.log("Selected Printer: ", user.value.PrinterAET);
        fileName.value = store.state.rootURL+"/templates/"+user.value.UserName+"/"+user.value.UserName+".jpg";
        console.log("UsersEdit", fileName.value);
    } else {
        title.value = "Add New User";
        editMode.value = false;
        if(printers.value.length>0){
            user.value.PrinterAET = printers.value[0].AET;
        }
    }
})

return (_ctx: any,_cache: any) => {
  const _component_modal_dialog = _resolveComponent("modal-dialog")!

  return (_openBlock(), _createBlock(_component_modal_dialog, {
    onCloseCancel: closeCancel,
    onCloseOk: closeOk,
    title: _unref(title),
    okBtn: "Accept",
    cnlBtn: "Cancel"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("UserEdit.UserName")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(user).UserName) = $event)),
          style: {"width":"85%"},
          maxlength: "25",
          readonly: _unref(editMode)
        }, null, 8, _hoisted_3), [
          [_vModelText, _unref(user).UserName]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("UserEdit.PassWord")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(user).PassWord) = $event)),
          style: {"width":"85%"},
          maxlength: "25",
          required: ""
        }, null, 512), [
          [_vModelText, _unref(user).PassWord]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("UserEdit.Rights")), 1),
        _withDirectives(_createElementVNode("select", {
          style: {"width":"85%"},
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(user).Rights) = $event))
        }, [
          _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t("UserEdit.GENERAL")), 1),
          _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t("UserEdit.ADMIN")), 1),
          _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t("UserEdit.RADIOLOGIST")), 1),
          _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t("UserEdit.REFERRING")), 1),
          _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t("UserEdit.MANAGER")), 1)
        ], 512), [
          [_vModelSelect, _unref(user).Rights]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createElementVNode("select", {
          style: {"width":"85%"},
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(user).TransSyntax) = $event))
        }, _hoisted_20, 512), [
          [_vModelSelect, _unref(user).TransSyntax]
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("UserEdit.Signature")), 1),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(user).Signature) = $event)),
          style: {"width":"85%","height":"100%"},
          rows: "3",
          cols: "25"
        }, null, 512), [
          [_vModelText, _unref(user).Signature]
        ])
      ], 512), [
        [_vShow, (_unref(user).Rights == 1) || (_unref(user).Rights == 2)]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_23, [
        _createElementVNode("img", {
          id: "SignatureImage",
          src: _unref(fileName),
          style: {"width":"100%"}
        }, null, 8, _hoisted_24),
        _createElementVNode("label", _hoisted_25, [
          _hoisted_26,
          _createTextVNode(_toDisplayString(_ctx.$t("UserEdit.SignaturePicture")), 1)
        ]),
        _createElementVNode("input", {
          type: "file",
          accept: "image/jpeg",
          onChange: loadSignature
        }, null, 32)
      ], 512), [
        [_vShow, (_unref(user).Rights == 1) || (_unref(user).Rights == 2)]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("UserEdit.DICOMPrinter")), 1),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(user).PrinterAET) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(printers), (item, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: item.AET
              }, _toDisplayString(item.AET), 9, _hoisted_30))
            }), 128))
          ], 512), [
            [_vModelSelect, _unref(user).PrinterAET]
          ])
        ])
      ], 512), [
        [_vShow, (_unref(user).Rights == 1) || (_unref(user).Rights == 2)]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})